import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ValidationSubmissionConfigurationResponse } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { ActionModal, Badge, Button, Flex, Modal, Typography, sanitizeRichDescription } from '@percent/lemonade'
import styles from './ProgramOutcomeEmails.module.scss'
import { ProgramDetailRow } from './Shared/ProgramDetailRow'

export function ProgramOutcomeEmails({
  shouldSendOutcomeEmail,
  acceptanceEmailBody,
  rejectionEmailBody
}: Pick<
  ValidationSubmissionConfigurationResponse,
  'acceptanceEmailBody' | 'shouldSendOutcomeEmail' | 'rejectionEmailBody'
>) {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState<'accept' | 'reject' | null>(null)

  const closeModal = () => setIsModalOpen(null)

  const sanitizedAccept = sanitizeRichDescription(acceptanceEmailBody ?? '')
  const sanitizedReject = sanitizeRichDescription(rejectionEmailBody ?? '')

  return (
    <>
      <Typography variant="h2">{t('typography.outcomeEmails')}</Typography>
      <Flex gap={16} direction="column">
        <ProgramDetailRow
          title={t('program.label.shouldSendOutcomeEmails')}
          status={shouldSendOutcomeEmail ? 'on' : 'off'}
        />

        <ProgramDetailRow title={t('program.label.acceptEmailBody')}>
          {acceptanceEmailBody ? (
            <Button size="small" variant="secondary" onClick={() => setIsModalOpen('accept')}>
              {t('button.show')}
            </Button>
          ) : (
            <Badge variant="default">{t('status.na')}</Badge>
          )}
        </ProgramDetailRow>

        <ProgramDetailRow title={t('program.label.rejectEmailBody')}>
          {rejectionEmailBody ? (
            <Button size="small" variant="secondary" onClick={() => setIsModalOpen('reject')}>
              {t('button.show')}
            </Button>
          ) : (
            <Badge variant="default">{t('status.na')}</Badge>
          )}
        </ProgramDetailRow>

        <Modal open={!!isModalOpen} onClose={closeModal}>
          {isModalOpen === 'accept' && (
            <ActionModal
              title={t('program.label.acceptEmailBody')}
              primaryButtonText={t('button.close')}
              primaryBtnTestId="show-accept-email-body"
              handleClose={closeModal}
              handleSubmit={closeModal}
            >
              <div
                className={styles.emailBody}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: sanitizedAccept }}
              />
            </ActionModal>
          )}
          {isModalOpen === 'reject' && (
            <ActionModal
              title={t('program.label.rejectEmailBody')}
              primaryButtonText={t('button.close')}
              primaryBtnTestId="show-reject-email-body"
              handleClose={closeModal}
              handleSubmit={closeModal}
            >
              <div
                className={styles.emailBody}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: sanitizedReject }}
              />
            </ActionModal>
          )}
        </Modal>
      </Flex>
    </>
  )
}
